export default "__VITE_ASSET__BrpD5TE1__"